import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyMock } from './currency.factory'
import { ShippingAddressMock } from './shippingAddress.factory'
import { type Location, type LocationV2 } from '../../models'

export const LocationMock = Factory.Sync.makeFactory<Location>({
  id: Factory.each(() => faker.random.number()),
  external_id: faker.random.word(),
  name: Factory.each(() => faker.random.words(3)),
  url: faker.internet.url(),
  logo: faker.image.imageUrl(),
  language: faker.random.number(),
  multipleLocations: true,
  locationTimezone: 'America/Vancouver',
  userLimit: 0,
  budgetOvertureToggle: true,
  purchase_filtering: false,
  catalog_permission: false,
  separate_expense_approval: true,
  standalone_travel_approval: true,
  phoneOne: faker.phone.phoneNumber(),
  phoneTwo: '',
  fax: '',
  email: faker.internet.email(),
  fiscalYearEndDay: 1,
  fiscalYearEndMonth: 12,
  timezone: -8,
  beginDate: faker.date.past(10),
  ported: true,
  port_date: null,
  active: true,
  fields_cache: '{}',
  activated: true,
  setup_stage: 'FIN',
  localCurrency: 1,
  contactPerson: null,
  buyerAddress: 1,
  shippingAddress: 2,
})

export const LocationV2Mock = Factory.Sync.makeFactory<LocationV2>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words(3)),
  url: faker.internet.url(),
  logo: faker.image.imageUrl(),
  currency: CurrencyMock.build(),
  phoneOne: '',
  fax: '',
  email: faker.internet.email(),
  primary_billing_address: Factory.each(() => ShippingAddressMock.build()),
  primary_shipping_address: Factory.each(() => ShippingAddressMock.build()),
  shipping_addresses: [],
  language: 1,
  locationTimezone: '',
  headquarter: false,
  user_count: faker.random.number(),
  department_count: faker.random.number(),
  active: true,
  external_id: faker.random.word(),
})
